import axios, { AxiosError } from 'axios'
import store from '@/store'
import router from '@/router'
import config from '@/config/app'

const onRequestFailed = async (error: AxiosError) => {
  if (error.response) {
    const { status } = error.response
    if (status === 401) {
      // unauthenticated / redirect
      await store.dispatch('auth/logout')
      await router.push({ name: 'Login' })
      return Promise.resolve()
    }
    if (status === 419) {
      // token expires / refresh
      await axios.get('/sanctum/csrf-cookie')
      return Promise.resolve()
    }
  }
  return Promise.reject(error)
}

axios.defaults.withCredentials = true
axios.defaults.baseURL = config.serverUrl
axios.interceptors.response.use(
  (response) => response,
  (error) => onRequestFailed(error)
)
